import { reactive, provide, inject } from 'vue';
import { PsProvider } from '../core/PsProvider';
import PsApiService from '@/api/PsApiService';
import Product from '@/object/AcceptCartItem';
import OrderDetails from '@/object/OrderDetails';
import PsResource from '@/api/common/PsResource';

export class AcceptItemProvider extends PsProvider {

    isNoMoreRecord = reactive<Boolean>(false);
    AcceptItemList = reactive<PsResource<Product[]>>(new PsResource());
    item = reactive<PsResource<OrderDetails>>(new PsResource());
    loading = reactive({
        value: false
    });

    limit: Number = 10;
    offset: Number = 0;

    id: string = "";
  static AcceptItemList: any;

    private updateItemList(responseData: PsResource<Product[]>) {

        if (this.AcceptItemList != null
            && this.AcceptItemList.data != null
            && this.AcceptItemList.data.length > 0
            && this.offset != 0) {

            if (responseData.data != null && responseData.data.length > 0) {
                this.AcceptItemList.data.push(...responseData.data);
            }else {
                this.isNoMoreRecord = true;
            }
            this.AcceptItemList.code = responseData.code;
            this.AcceptItemList.status = responseData.status;
            this.AcceptItemList.message = responseData.message;

        } else {

            this.AcceptItemList = responseData;


        }

        if (this.AcceptItemList != null && this.AcceptItemList.data != null) {
            this.offset = this.AcceptItemList.data.length;
        }

    }
     

    async AddOrderDetails(loginUserId: string,AddressId: string) {

        this.loading.value = true;
        
        this.item = await PsApiService.AddOrderDetails<OrderDetails>(new OrderDetails(), loginUserId, AddressId);
        
        console.log(this.item,"data-=-=-=")
    
        this.loading.value = false;

        return this.item;

    }
    async getAcceptItem(loginUserId: string) {

        this.loading.value = true;
        
        const responseData = await PsApiService.getAcceptItem<Product>(new Product(), loginUserId);
        this.updateItemList(responseData)
        console.log(responseData,"data-=-=-=")
    
        this.loading.value = false;

        return responseData;

    }
}

export const AcceptItemProviderSymbol = Symbol('AcceptItemProvider')
export const createAcceptItemProviderState = () => {
    return reactive(new AcceptItemProvider())
}
export const loadAcceptItemList = () => {
    return reactive(new AcceptItemProvider())
}

export const useAcceptItemProviderState = () => inject(AcceptItemProviderSymbol) as AcceptItemProvider
export const provideAcceptItemProviderState = () => provide(
    AcceptItemProviderSymbol,
    createAcceptItemProviderState()
)